var AppConfig_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppControllerService } from "./app-controller.service";
let AppConfig = class AppConfig {
    static { AppConfig_1 = this; }
    http;
    appController;
    static settings;
    constructor(http, appController) {
        this.http = http;
        this.appController = appController;
    }
    load() {
        const uniqueParam = new Date().getTime();
        const jsonFile = `assets/config/config.json?cacheBuster=${uniqueParam}`;
        return new Promise((resolve, reject) => {
            {
                this.http.get(jsonFile).toPromise().then((response) => {
                    AppConfig_1.settings = response;
                    this.appController.configLoadedComplete(true);
                    resolve();
                }).catch((response) => {
                    reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
                });
            }
        });
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppControllerService }
    ];
};
AppConfig = AppConfig_1 = __decorate([
    Injectable({
        providedIn: "root",
    })
], AppConfig);
export { AppConfig };
